import styled from 'styled-components'

type CheckBoxProps = {
    checked: boolean,
    color?: string;
}

const CheckboxContainer = styled.div<any>`
    display: inline-block;
    vertical-align: middle;
    ${props => props.disabled ? 'opacity: .4;' : ''}
`

// Hide checkbox visually but remain accessible to screen readers.
// Source: https://polished.js.org/docs/#hidevisually
const HiddenCheckbox = styled.input.attrs({ type: 'checkbox' })`
    border: 0;
    clip: rect(0 0 0 0);
    clippath: inset(50%);
    height: 1px;
    margin: -1px;
    overflow: hidden;
    padding: 0;
    position: absolute;
    white-space: nowrap;
    width: 1px;
`

const StyledCheckbox = styled.div<CheckBoxProps>`
    display: inline-block;
    width: 15px;
    height: 15px;
    box-sizing: border-box;
    margin-right: 10px;
    border: 1px solid ${props => (props.color ?? '#E2E2E2')};
    background: ${props => (props.checked ? props.color : 'white')};
    border-radius: 3px;
    transition: all 150ms;

    /* ${HiddenCheckbox}:focus + & {
        box-shadow: 0 0 0 3px pink;
    } */
`

export {
    CheckboxContainer,
    HiddenCheckbox,
    StyledCheckbox
}